<template>
  <v-row density="compact">
    <p>
      Williams %R measures how close the price is to its N-day high (ranges from 0 to -100).
      Readings near 0 (e.g. above -20) are overbought; readings near -100 (below -80) are oversold.
      Enter the threshold as a positive number.
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days"
        :items="hl_days"
        item-title="title"
        item-value="value"
        label="Lookback Window"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.above_below"
        :items="above_below"
        item-title="title"
        item-value="value"
        label="Near High or Near Low"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.threshold"
        density="compact"
        hide-details
        variant="outlined"
        label="Threshold (positive, e.g. 20 or 80)"
        @update:model-value="updateConfig('threshold', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      above_below: [
        { title: 'Near the highs / overbought (%R >= -threshold)', value: 'above' },
        { title: 'Near the lows / oversold (%R <= -threshold)', value: 'below' }
      ],
      hl_days: [
        { title: '1 week (5 days)', value: 5 },
        { title: '2 weeks (10 days)', value: 10 },
        { title: '3 weeks (15 days)', value: 15 },
        { title: '1 month (20 days)', value: 20 },
        { title: '50 days', value: 50 },
        { title: '90 days', value: 90 },
        { title: '6 months (125 days)', value: 125 },
        { title: '1 year (250 days)', value: 250 }
      ],
      defaultTa: {
        enabled: true,
        rule_type: 'williams_r',
        days: 20,
        above_below: 'below',
        threshold: 80,
        long_short: 'long'
      }
    }
  },

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'williams_r') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
